import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import Header from "../header/Header";
import { ContentFinderContext } from "../../context/ContentFinderContext";
import ContentFinderRecordType from "./ContentFinderRecordType";
import ContentFinderIdType from "./ContentFinderIdType";
import ContentFinderSearch from "./ContentFinderSearch";
import ContentFinderSearchGrid from "./ContentFinderSearchGrid";
import {
  RECORD_TYPES,
  ID_TYPES,
  ASSET_TYPE,
  MAP_PLACEHOLDER,
} from "../../constants/ContentFinder";
import "../../styles/media-search.scss";
import "../../styles/contentFinder.scss";

const ContentFinderRequest = () => {
  const {
    recordType,
    idType,
    _setRecordType,
    _setIdType,
    searchContent,
    searchValue,
    _setSearchValue,
    loading,
    results,
    hasSearched,
    _setResults,
    _setHasSearched,
    pageError,
    _setPageError,
  } = useContext(ContentFinderContext);

  return (
    <Row>
      <Col>
        <div className="media-request-header-button-link">
          <Header
            headingText="Legacy GMSC"
            mode="contentFinder"
          />
        </div>

        <div className="mediaSearchWrapper">
          <Row className="mediaSearchContainer">
            <Col className="m-0 p-0" xs={1.5}>
              <ContentFinderRecordType
                value={recordType}
                options={RECORD_TYPES}
                onChange={(value) => {
                  _setRecordType(value);
                  _setIdType("");
                  _setSearchValue("");
                  _setResults([]);
                  _setHasSearched(false);
                  _setPageError(false);
                }}
              />
            </Col>

            {recordType === ASSET_TYPE.ID && (
              <Col xs={2}>
                <div>
                  <ContentFinderIdType
                    value={idType}
                    options={ID_TYPES}
                    onChange={(value) => {
                      _setIdType(value);
                      _setSearchValue("");
                      _setResults([]);
                      _setHasSearched(false);
                      _setPageError(false);
                    }}
                  />
                </div>
              </Col>
            )}

            {(
              recordType === ASSET_TYPE.TITLE ||
              (recordType === ASSET_TYPE.ID && idType)
            ) && (
              <Col
                xs= {8}
              >
                <ContentFinderSearch
                  recordType={recordType}
                  value={searchValue}
                  placeholder={MAP_PLACEHOLDER[recordType][idType] ?? MAP_PLACEHOLDER[recordType]}
                  onChange={(value) => {
                    _setSearchValue(value);
                    _setResults([]);
                    _setHasSearched(false);
                    _setPageError(false);
                  }}
                  onSearch={searchContent}
                />
              </Col>
            )}
          </Row>
        </div>
        <ContentFinderSearchGrid 
          results={results} 
          loading={loading} 
          hasSearched={hasSearched} 
          pageError={pageError}
        />
      </Col>
    </Row>
  );
};

export default ContentFinderRequest;
